const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.125 4.75H12.125C12.788 4.75 13.4239 5.01339 13.8928 5.48223C14.3616 5.95107 14.625 6.58696 14.625 7.25V14.75C14.625 14.9158 14.5592 15.0747 14.4419 15.1919C14.3247 15.3092 14.1658 15.375 14 15.375H4C3.33696 15.375 2.70107 15.1116 2.23223 14.6428C1.76339 14.1739 1.5 13.538 1.5 12.875V5.375C1.5 5.20924 1.56585 5.05027 1.68306 4.93306C1.80027 4.81585 1.95924 4.75 2.125 4.75Z",
    fill: "white",
    stroke: "#5A045A",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 8.8125L19 6.3125V13.8125L14.625 11.3125",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/VideoCamera.a0cd3eeff393b2cdbc9eb0c6c1a5cf64.svg";
export { ForwardRef as ReactComponent };